















export default {
  props: ['menu'],
};
